export default __webpack_public_path__ + "media/zurb/img/services/services/emerging-tech-img-003c1ef60ed28497a6fed0a99f321d2c.jpg";